"use client"
// src/blocks/link/link.tsx
import { trackEvent } from "@a24/analytics";
import NextLink from "next/link";
import { jsx } from "react/jsx-runtime";
var Link = ({
  children,
  className,
  href,
  id,
  openNewTab,
  target,
  title,
  tracking,
  disabled = false,
  ...rest
}) => {
  if (!(children && href)) return null;
  const urlRegEx = RegExp(
    /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)/gi
  );
  const isExternal = openNewTab || urlRegEx.test(href.toString());
  if (isExternal)
    return /* @__PURE__ */ jsx(
      "a",
      {
        className: `${className} ${disabled ? "cursor-default pointer-events-none" : ""}`,
        href: href.toString(),
        id,
        rel: "noreferrer noopener",
        target: "_blank",
        title,
        onClick: (event) => {
          if (disabled) {
            event.preventDefault();
            return;
          }
          trackEvent({
            name: "link_interaction",
            data: {
              value: `${tracking?.module}|${tracking?.layout}|${tracking?.component}|${tracking?.label}|`
            }
          });
        },
        ...rest,
        children
      }
    );
  return /* @__PURE__ */ jsx(
    NextLink,
    {
      className: `${className} ${disabled ? "cursor-default pointer-events-none" : ""}`,
      href: href.toString().startsWith("/") ? href : `/${href.toString()}`,
      id,
      onClick: (event) => {
        if (disabled) {
          event.preventDefault();
          return;
        }
        trackEvent({
          name: "link_interaction",
          data: {
            value: `${tracking?.module}|${tracking?.layout}|${tracking?.component}|${tracking?.label}|`
          }
        });
      },
      title,
      ...rest,
      children
    }
  );
};
var link_default = Link;

export {
  link_default
};
